import * as React from 'react';
import { Translate } from '../../../shared/LanguageService';
import { Table } from 'react-bootstrap';
import { ISpecialAuthorizationsGroup, ISpecialAuthorization } from './Types';
import SpecialAuthorizationsListGroup from './SpecialAuthorizationsListGroup';
import { assign } from '../../../shared/Assign';

interface ISpecialAuthorizationsListProps {
    groups: ISpecialAuthorizationsGroup[];
    toggleExpansion: (value: number) => void;
    toggleItemIsAssigned: (item: ISpecialAuthorization) => void;
}

const SpecialAuthorizationsList = (props: ISpecialAuthorizationsListProps) => {
    return (
        <div className="special-auth">
            {assign({}, props)
                .groups.sort(
                    (a: ISpecialAuthorizationsGroup, b: ISpecialAuthorizationsGroup) =>
                        a.value - b.value
                )
                .map((g: ISpecialAuthorizationsGroup) => {
                    return (
                        <SpecialAuthorizationsListGroup
                            group={g}
                            key={g.value}
                            toggleExpansion={props.toggleExpansion}
                            toggleItemIsAssigned={props.toggleItemIsAssigned}
                        />
                    );
                })}
        </div>
    );
};

export default SpecialAuthorizationsList;
